import type { FC } from "react";
import React, { useEffect, useRef } from "react";
import { Box, keyframes } from "@edreamsodigeo/prisma-design-system";

import type { FadeAnimationProps } from "~/components/common/animation/Fade/contract";

const fadeIn = keyframes`
  0% {
    visibility: hidden;
    opacity: 0;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    visibility: visible;
    opacity: 1;
  }
  100% {
    visibility: hidden;
    opacity: 0;
  }
`;

const Fade: FC<FadeAnimationProps> = ({
  children,
  duration,
  delay = 0,
  visible,
  ...args
}) => {
  const wasVisible = useRef(visible);
  useEffect(() => {
    if (visible) {
      wasVisible.current = true;
    }
  }, [visible]);
  const animation = visible ? fadeIn : fadeOut;

  return (
    <Box
      sx={{
        animation:
          (visible || wasVisible.current) &&
          `${animation} ${duration}ms linear ${delay}ms`,
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
      }}
      {...args}
    >
      {children}
    </Box>
  );
};

export default Fade;
